import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { LucideAngularModule } from "lucide-angular";
import { InviteMemberButtonModule } from "./component/invite-member-button/invite-member-button.module";
import { OrganizationDetailsModule } from "./component/organization-details/organization-details.module";
import { OrganizationPageComponent } from "./organization-page.component";

@NgModule({
  declarations: [OrganizationPageComponent],
  imports: [CommonModule, RouterModule, TranslateModule, LucideAngularModule, OrganizationDetailsModule, InviteMemberButtonModule],
})
export class OrganizationPageModule {}
